module.exports = __webpack_public_path__ + "static/media/wallet.3a342cc9.svg";